export const DIRECTIONS = {
  UP: 'up',
  UP_RIGHT: 'up_right',
  RIGHT: 'right',
  DOWN_RIGHT: 'down_right',
  DOWN: 'down',
  DOWN_LEFT: 'down_left',
  LEFT: 'left',
  UP_LEFT: 'up_left',
}
